import React, { useCallback, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useSnackBar } from "../../../hooks/snackBar";
import ModalOportunidade from "../ModalOportunidade";
import globals from "../../../globals";

function ResumoOportunidade() {
  const { id } = useParams();
  const history = useHistory();
  const { addSnackBar } = useSnackBar();
  const [modalData, setModalData] = useState({});


  return (
    <ModalOportunidade
      showModal
      handleCloseModal={() => window.location = globals.REACT_APP_URL_BASE_FRONT_PORTAL}
      data={modalData}
    />
  );
}

export default ResumoOportunidade;
